<div class="bg-m0 flex h-[700px] select-none flex-col p-9">
  <div
    data-cy="malloyModelsDialogTitle"
    class="text-s2 mt-5 text-left text-2xl font-semibold"
    >Malloy file Models</div
  >

  <div *ngIf="models?.length === 0" class="text-s1 mt-9 select-text text-lg">
    Add the <span class="text-red-700">#(mprove) model</span> tag to the malloy
    source. Then click <span class="font-semibold">Save and Validate</span> to
    create Mprove Model.
  </div>

  <div
    *ngIf="models?.length > 0"
    class="text-s2 mb-3 mt-9 text-lg font-semibold"
    >Models:</div
  >

  <div
    class="flex flex-1 flex-shrink-0 flex-row items-center justify-center"
    *ngIf="!models"
  >
    <div class="relative flex h-9 w-9">
      <ngx-spinner
        [name]="spinnerName"
        color="#0084d1"
        bdColor="#00000000"
        size="default"
        type="ball-clip-rotate"
        [fullScreen]="false"
        [disableAnimation]="true"
        [zIndex]="10"
      >
      </ngx-spinner>
    </div>
  </div>

  <div class="overflow-y-auto" *ngIf="!!models">
    <div
      class="text-s1 rounded py-[10px] pl-5 text-base"
      [ngClass]="{
        'hover:bg-m50 hover:cursor-pointer': model.hasAccess === true
      }"
      *ngFor="let model of models"
      (click)="navToModel(model.modelId)"
    >
      <ng-template #templateModelsModel>
        <div *ngIf="isExplorer === false">Explorer role required</div>
        <div *ngIf="isExplorer === true">No access to model</div>
      </ng-template>

      <div
        class="flex select-none flex-row"
        [tp]="templateModelsModel"
        [tpIsEnabled]="model.hasAccess === false"
      >
        <div class="flex flex-row">
          <div class="flex">
            {{ model.label }}

            <span class="text-s400 ml-[5px]">- {{ model.connectionType }}</span>
          </div>

          <m-lock-closed-icon
            class="text-s400 mb-1 ml-2 mr-5"
            *ngIf="model.hasAccess === false"
          ></m-lock-closed-icon>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isExplorer$ | async"></div>
